import * as Yup from 'yup';
import validation from '../../../../../utils/validation';

export const validationSchema = Yup.object().shape({
  name: Yup.string()
    .required('First name is required')
    .max(50, 'Maximum length is 50 characters')
    .test(
      'Apostrophe is not allowed in name',
      'Apostrophe is not allowed in name',
      (value) => {
        const _v = value || '';
        return !_v.match(/^.*'.*$/);
      },
    ),
  surname: Yup.string()
    .required('Last name is required')
    .max(50, 'Maximum length is 50 characters')
    .test(
      'Apostrophe is not allowed in name',
      'Apostrophe is not allowed in name',
      (value) => {
        const _v = value || '';
        return !_v.match(/^.*'.*$/);
      },
    ),
  title: Yup.string().max(50, 'Maximum length is 50 characters'),
  escalationLevel: Yup.number().required('Escalation level is required'),
  email: Yup.string()
    .required('Email is required')
    .email('Valid email is required'),
  // password: validation.password.matches(
  //   /^.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?].*$/,
  //   'Need one special character',
  // ),
  // confirmPassword: validation.confirmPassword,
  // workDays: Yup.array().required('Word day is required'),
  // startWork: Yup.date('Start work is required')
  //   .typeError('Start work is required')
  //   .required('Start work is required'),
  // endWork: Yup.date('End work is required')
  //   .typeError('End work is required')
  //   .required('End work is required'),
  initials: Yup.string().required('Initials is required'),
  departmentId: Yup.string().required('Department is required'),
  roleNames: Yup.string().required('Role is required'),
  groupIdArray: Yup.array().required('Membership group is required'),
});
